export { default, getServerSideProps } from "pages/[lang]/tag/[tag]";
